import React, {  useState } from 'react';
import './HelpCenter.css';

import { PageTitle, FaqItem, CaseTabs } from '../../../components';
import { helpFAQs } from '../../../constants';



const HelpCenter = () => {

  // Get all FAQ category names
  const categories = Object.keys(helpFAQs);

  // Track current selected category (defaults to first one)
  const [category, setCategory] = useState(categories[0]);

  // Track which question is expanded in each category
  const [activeAccordionMap, setActiveAccordionMap] = useState(() => {
    const initialMap = {};
    categories.forEach((cat) => {
      // Default to first question in each category
      initialMap[cat] = helpFAQs[cat][0]?.question || null;
    });
    return initialMap;
  });

  // Toggle accordion expansion for current category
  const handleAccordionClick = (id) => {
    setActiveAccordionMap(prev => ({
      ...prev,
      [category]: prev[category] === id ? null : id // Toggle clicked item
    }));
  };

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Help Center'} page={'Help Center'} />

      <div className='help-center'>
        <section className='tab-info'>
          {/* Category Tabs */}
          <ul className="tab-buttons">
            {categories.map((item) => (
              <CaseTabs
                key={item}
                id={item}
                title={item.replace(/([A-Z])/g, ' $1').trim()} // Format category name
                setSelected={() => setCategory(item)}
                active={category === item}
                Icon={true} // CaseTabs supports an icon prop
              />
            ))}
          </ul>

          {/* FAQ Content based on selected category */}
          <div className='tab-sections'>
            <div className='faq tab-section active'>
              {/* Faq Accordion container */}
              <div className='accordion-container'>
                {/* Filter and render FAQs based on selected category */}
                {helpFAQs[category].map((faq) => (
                  <FaqItem
                    key={faq.question}
                    id={faq.question}
                    title={faq.question}
                    content={faq.answer}
                    isActive={faq.question === activeAccordionMap[category]}
                    onAccordionClick={handleAccordionClick}
                  />

                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HelpCenter;